import { sendLeadMail as sendLeadMailRequest } from '@/services/leadMail'

export default {
  methods: {
    async submitLeadMail (options = {}) {
      const component = options.component || this.$options.name
      const advertiserLogin = options.advertiserLogin || (this.sitimmoUser && this.sitimmoUser.login)
      const response = await sendLeadMailRequest({ ...options, component, advertiserLogin })
      const successMessageKey = options.successMessageKey || 'portals.optimizeBroadcast.messageSendMail'
      const errorMessageKey = options.errorMessageKey || 'error.found'

      if (response.type === 'success') {
        this.$message({ message: this.$t(successMessageKey), type: 'success' })
      } else {
        this.$message({ message: this.$t(errorMessageKey), type: 'error' })
      }

      return response
    }
  }
}
